import { CsvExportParams, ExcelExportParams, IDetailCellRendererParams } from 'ag-grid-community';

export interface DetailGridConfig {
  masterDetail: boolean;
  detailGridRendererParams: IDetailCellRendererParams;
  detailCsvExportParams: CsvExportParams | undefined;
  detailExcelExportParams: ExcelExportParams | undefined;
}

export const defaultDetailGridConfig: DetailGridConfig = {
  masterDetail: true,
  detailGridRendererParams: undefined,
  detailCsvExportParams: undefined,
  detailExcelExportParams: undefined,
};
